import { Toaster } from "#/components/ui/sonner.tsx";

function ComponentInitializer() {
	return <Toaster position="bottom-right" />;
}

export default ComponentInitializer;
